import {
  canShowSketchPropertySection,
  registerPropertyManagerSection,
  SketchCornerMode,
  SketchPropertySectionCommandSessionPolicy,
} from '@/core';
import SketchCornerPropertySection from '@/components/editor/property-manager/sketch-corner/SketchCornerPropertySection.vue';

/**
 * 退出草图圆角命令前统一清理选择，避免属性面板回退到线条属性。
 * @param context 属性面板上下文。
 */
function exitSketchCornerCommand(context: {
  clearSelection?: () => void;
  setSketchCornerMode?: (mode: SketchCornerMode | null) => void;
}): void {
  context.clearSelection?.();
  context.setSketchCornerMode?.(null);
}

registerPropertyManagerSection({
  id: 'sketch-corner',
  title: (context) => (context.sketchCornerMode === SketchCornerMode.Chamfer ? '草图倒角' : '草图圆角'),
  order: 15,
  component: SketchCornerPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => {
    return canShowSketchPropertySection(
      context,
      context.isSketchActive && context.sketchCornerEnable === true,
      SketchPropertySectionCommandSessionPolicy.AllowCurrentCommand,
    );
  },
  onConfirm: (context) => {
    const viewer = context.renderer;
    if (context.sketchCornerMode === SketchCornerMode.Fillet) {
      const hasPendingPreview = viewer?.hasPendingSketchCornerFilletPreview?.() ?? false;
      if (!hasPendingPreview) {
        exitSketchCornerCommand(context);
        return;
      }
      const confirmed = viewer?.confirmSketchCornerFilletPreview?.() ?? false;
      if (!confirmed) {
        return;
      }
      return;
    }
    exitSketchCornerCommand(context);
  },
  onCancel: (context) => {
    const viewer = context.renderer;
    if (context.sketchCornerMode === SketchCornerMode.Fillet) {
      viewer?.cancelSketchCornerFilletPreview?.();
    }
    exitSketchCornerCommand(context);
  },
});
